import { render, staticRenderFns } from "./ATGColumnTemplate.vue?vue&type=template&id=dc04115c&scoped=true"
import script from "./ATGColumnTemplate.vue?vue&type=script&lang=js"
export * from "./ATGColumnTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc04115c",
  null
  
)

export default component.exports